export default __webpack_public_path__ + "static/media/ic_wcanto_40.375396e8.svg";